"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChordFromNotes = void 0;
const notes_1 = require("./notes");
const chords_1 = require("./chords");
function getChordFromNotes(...notesOrNames) {
    let notes;
    if (typeof notesOrNames[0] === "string") {
        notes = notesOrNames.map(n => (0, notes_1.getNote)(n));
    }
    else {
        notes = notesOrNames.slice();
    }
    if (notes.length > 0) {
        // Remember the bass note before sorting
        const bass = notes[0].name;
        // Put into natural order
        notes = (0, notes_1.sortNotes)(notes);
        for (let i = 0; i < notes.length; i++) {
            // First get the intervals
            const ints = getIntervals(notes);
            const quality = lookupQualityByIntervals(ints);
            if (quality !== undefined) {
                // found it
                return (0, chords_1.getChord)(notes[0], quality, bass);
            }
            else {
                // try next
                notes = getNextPermutation(notes);
            }
        }
    }
    // Not found
    return undefined;
}
exports.getChordFromNotes = getChordFromNotes;
function getNextPermutation(notes) {
    notes.push(notes.shift());
    return notes;
}
function lookupQualityByIntervals(intervals) {
    for (const i in chords_1.CHORD_INTERVALS) {
        const quality = i;
        const chordInts = (0, chords_1.getChordIntervals)(quality);
        if (compareIntervals(chordInts, intervals)) {
            return quality;
        }
    }
    return undefined;
}
/** Gets the intervals for the notes */
function getIntervals(notes) {
    const ints = [];
    ints.push(0);
    const base = notes[0].number;
    for (let i = 1; i < notes.length; i++) {
        let num = notes[i].number;
        if (num < base)
            num += 12;
        ints.push(num - base);
    }
    return ints;
}
/* Checks to see if two sets of note intervals are the same */
function compareIntervals(ints1, ints2) {
    if (ints1.length === ints2.length) {
        for (let i = 0; i < ints1.length; i++) {
            if (ints1[i] !== ints2[i]) {
                return false;
            }
        }
        return true;
    }
    return false;
}
//# sourceMappingURL=chord-lookup.js.map